import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppText } from 'shared/UI/UIKit/Text';
import type { CalendarEvent } from 'features/production-calendar/components/List/model/types';
import { DateModalFooter } from '../../Footer';
import { useDeleteModal } from '../model';

interface DeleteDateModalProps {
  visible: boolean;
  onItemDelete: () => void;
  hide: () => void;
  calendarEvent: CalendarEvent | null;
}

export const DeleteDateModal = ({
  visible,
  onItemDelete,
  hide,
  calendarEvent,
}: DeleteDateModalProps) => {
  const {
    state: { loading },
    methods: { hideModal, onSubmit },
  } = useDeleteModal({ hide, onItemDelete, calendarEvent });

  const footer = <DateModalFooter onSubmit={onSubmit} hideModal={hideModal} title="Удалить" />;
  const content = <AppText>Подтвердите удаление выбранной даты</AppText>;

  return (
    <AppModal
      visible={visible}
      onCancel={hideModal}
      content={content}
      maskClosable={false}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Удалить дату"
    />
  );
};
